import LogoDark from '@assets/logos/logo-dark.svg'
import LogoLight from '@assets/logos/logo-light.svg'
import LogoMarkReversed from '@assets/logos/logo-mark-reversed.svg'
import LogoMark from '@assets/logos/logo-mark.svg'
import LogoPride from '@assets/logos/logo-pride.png'

export function resolveLogo(mode = 'light', small = false) {
  if (small) return mode === 'dark' ? LogoMarkReversed : LogoMark
  if (new Date().getMonth() === 5) return LogoPride
  return mode === 'dark' ? LogoLight : LogoDark
}
